import React from 'react';
import {Link, NavLink} from 'react-router-dom';
import {Button, DropdownButton, Glyphicon, MenuItem} from "react-bootstrap";
import {signOut} from "../firebase";
import {LinkContainer} from "react-router-bootstrap";

export default class Navbar extends React.Component {

    toggleSidebar() {
        let root = document.getElementById("root");
        root.className += " sidebar-visible";
        document.getElementById("sidebar-layout-obfuscator").onclick = function(){
            root.className = root.className.replace(" sidebar-visible", "");
        }
    }

    logout(){
        signOut();
        this.props.setActiveUser(null);
        window.location.href="/";
    }


    render() {
        const {user} = this.props;
        return (
            <header className="header-container">
                <nav className="container container-md">
                    <Link to={!!user ? "" : "/"}><img src="/resources/images/logo-white-translucent.png" alt="T-Rex" id="trex-logo" /></Link>

                    {user && (
                        <ul className="tabs">
                            <li><NavLink exact to="/">Report</NavLink></li>
                            <li><NavLink to="/projects">Projects</NavLink></li>
                            <li><NavLink to="/reporting">Reporting</NavLink></li>
                        </ul>
                    )}

                    <ul className="pull-right">
                        {user && (
                            <li>
                                <DropdownButton pullRight noCaret title={
                                    <span>
                                        <span className="hidden-xs">{user.name || ""} <span className="caret" /></span>
                                        <span className="visible-xs"><Glyphicon glyph="option-vertical" /></span>
                                    </span>
                                } id="bg-nested-dropdown">
                                    <LinkContainer to="/user"><MenuItem>My Account</MenuItem></LinkContainer>
                                    <MenuItem key="divider" divider />
                                    <LinkContainer to="/feedback"><MenuItem>Send Feedback</MenuItem></LinkContainer>
                                    {user.admin && ([
                                        <LinkContainer key="team" to="/team"><MenuItem>Team Management</MenuItem></LinkContainer>,
                                        <MenuItem key="divider" divider />
                                    ])}

                                    <MenuItem onClick={this.logout.bind(this)}>Sign Out</MenuItem>
                                </DropdownButton>
                            </li>
                        )}
                        {user === undefined && window.location.href.indexOf("sign-in") === -1 && (
                            <li>
                                <div className="btn-group">
                                    <Link to="/sign-in"><Button style={{verticalAlign: "middle", display: "inline-block"}}>Sign In</Button></Link>
                                </div>
                            </li>
                        )}
                        <li>&nbsp;</li>
                    </ul>
                </nav>
            </header>
        )
    }
};


// WEBPACK FOOTER //
// ./src/layout/Navbar.js